<template>
  <div @click="doCheckIn">
<!--    <icon-svg icon-class="qiandao" :class="['checkin-icon',isCheckIn?'is-checkin':'']"></icon-svg>-->
    <Button type="warning" plain round size="small" :disabled="isCheckIn? true: false">{{checkinText}}</Button>
  </div>

</template>

<script>
  import {
    Toast, Button
  } from "vant"

  export default {
    name: "CheckInIcon",
    components: {
      Button
    },
    data() {
      return {
        currentUserInfo: {}
      }
    },
    mounted() {
      this.InitCachedUserInfo()
    },
    methods: {
      doCheckIn() {
        if (this.isCheckIn) {
          return
        }

        this.$store.dispatch("CheckIn").then(data => {
          if (data.code === 0 && data.data.success) {
            let msg = `签到成功 奖励 ${data.data.award_credit} 币`
            Toast({
              "message": msg,
              "duration": 2000,
            })
            this.InitUserInfo()
          } else if (data.code === 20010) {
            this.$router.push("/login")
          }
        })
      },
      InitCachedUserInfo() {
        this.$store.dispatch("CacheAccountInfoMine").then((data) => {
          if (data.id) {
            this.currentUserInfo = data
          }
        }, () => {
        })
      },
      InitUserInfo() {
        this.$store.dispatch("AccountInfoMine").then((data) => {
          if (data.code === 0) {
            this.currentUserInfo = data.data
          }
        }, () => {
        })
      }

    },
    computed: {
      isCheckIn() {
        if ((this.currentUserInfo) && (this.currentUserInfo.id) && this.currentUserInfo.checkin_status) {
          return true
        } else {
          return false
        }
      },
      checkinText() {
        if (this.isCheckIn) {
          return "已签到"
        } {
          return "签到"
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  .checkin-icon {
    color: grey;
  }

  .is-checkin {
    color: #fc9153;
  }

  .checkin-name {
    font-size: 16px;
  }
</style>
